import React, { ReactNode } from "react"
import styled, { css } from "styled-components"

import { Color, SpacingSize, TextSize, Transition } from "~/consts/style-mixins"

interface Props {
  children: string | ReactNode
  size: keyof typeof SizeType
  onClick?: Function
  isButton?: boolean
  disabled?: boolean
  className?: string
}

interface StyledProps {
  styledTextBySize: string
  styledButtonBySize: string
  isButton?: boolean
  disabled?: boolean
}

const SizeType = {
  Medium: "Medium",
  Small: "Small",
  XSmall: "XSmall",
}

const FunctionLink = ({ children, size, onClick, isButton, disabled, className }: Props) => {
  return (
    <StyledFunctionLink
      className={className}
      styledTextBySize={styledTextBySize[size]}
      styledButtonBySize={styledButtonBySize[size]}
      isButton={isButton}
      disabled={disabled}
      onClick={disabled ? undefined : (onClick as () => void)}
    >
      {children}
    </StyledFunctionLink>
  )
}

const styledTextBySize = {
  Medium: `
    font-size: ${TextSize.M}px
  `,
  Small: `
    font-size: ${TextSize.S}px
  `,
  XSmall: `
    font-size: ${TextSize.XS}px
  `,
}

const styledButtonBySize = {
  Medium: `
    padding: ${SpacingSize.M}px ${SpacingSize.XS}px;
    border-radius: 24px;
  `,
  Small: `
    padding: 11px ${SpacingSize.XS}px;
    border-radius: 18px;
  `,
  XSmall: `
    padding: 9px ${SpacingSize.XS}px;
    border-radius: 16px;
  `,
}

const StyledFunctionLink = styled.a`
  font-weight: bold;
  display: inline-block;
  width: 100%;
  color: ${Color.Secondary};
  line-height: 1;
  ${Transition.Hover};
  ${({ isButton, disabled, styledTextBySize, styledButtonBySize }: StyledProps) => css`
    ${styledTextBySize}
    ${isButton &&
    css`
      text-align: center;
      border: 1px solid ${Color.Secondary};
      box-sizing: border-box;
      &:hover {
        border: 1px solid ${Color.SecondaryDark};
        background: ${Color.BackgroundGray};
      }
      ${styledButtonBySize}
    `}
    ${disabled &&
    css`
      color: ${Color.Gray} !important;
      border-color: ${Color.Gray} !important;
      &:hover {
        cursor: not-allowed !important;
      }
    `}
  `}
  &:hover {
    cursor: pointer;
    color: ${Color.SecondaryDark};
  }
`

export default FunctionLink
